import Component from './lose_reason_dialog.vue'
export default Component
